import moment from 'moment-timezone';

export const utcToTimezone = (date, { timezone, format = 'YYYY-MM-DD HH:mm:ss z' } = {}) =>
  moment
    .utc(date)
    .tz(timezone ?? moment.tz.guess())
    .format(format);
